// get all
export const FLAG_GETTING_IDENTIFICATION_TYPES = 'FLAG_GETTING_IDENTIFICATION_TYPES';
export const SHOW_ERROR_GETTING_IDENTIFICATION_TYPES = 'SHOW_ERROR_GETTING_IDENTIFICATION_TYPES';
export const CLEAR_ERROR_GETTING_IDENTIFICATION_TYPES = 'CLEAR_ERROR_GETTING_IDENTIFICATION_TYPES';
export const GET_IDENTIFICATION_TYPES = 'GET_IDENTIFICATION_TYPES';
export const CLEAR_IDENTIFICATION_TYPES = 'CLEAR_IDENTIFICATION_TYPES';
